/**
 * User: Rob Richard
 * Date: 8/11/14
 * Time: 7:21 PM
 */

'use strict';

const get = require('lodash.get');
const SV = require('server-vars');
const redirects = require('./checkout-redirects.es');
const errorsCopy = require('../copy/checkoutErrors');
const { PAGES } = require('./../models/checkoutConstants.es');

let checkoutType;
let isPrivateOffer;
let isPreAuthNegotiation;

const helpers = module.exports = {

    setPageType(pageType) {
        checkoutType = pageType;
    },
    setCheckoutProps(transaction) {
        isPrivateOffer = get(transaction, 'isPrivateOffer');
        isPreAuthNegotiation = get(transaction, 'isPreAuthNegotiation');
    },
    getCheckoutType() {
        return checkoutType || PAGES.PAGE_CHECKOUT;
    },
    isCheckout() {
        return helpers.getCheckoutType() === PAGES.PAGE_CHECKOUT;
    },
    isBalanceDue() {
        return helpers.getCheckoutType() === PAGES.PAGE_BALANCE_DUE || redirects.isBalanceDueByUrl();
    },
    isConfirmation() {
        return helpers.getCheckoutType() === PAGES.PAGE_CONFIRMATION ||
            SV.get('settings.pageSubType') === PAGES.PAGE_CONFIRMATION;
    },
    isFullPrice() {
        return redirects.getCheckoutParam('fullPrice') === 'true';
    },
    isNegotiable() {
        const amount = redirects.getCheckoutParam('offerAmount');
        return !!amount && amount !== redirects.getCheckoutParam('listPrice');
    },
    isPrivateOffer() {
        return isPrivateOffer;
    },
    isPreAuthNegotiation() {
        return isPreAuthNegotiation;
    },
    isNetPriceBuyer(item, buyer, transaction) {
        const hasNetPrice = get(transaction, 'hasNetPrice');
        const isFurniture = get(item, 'isFurniture');
        const isTradeBuyer = get(buyer, 'isVerifiedTrade');
        return isFurniture && isTradeBuyer && hasNetPrice;
    },
    getErrorCopy(error) {
        return errorsCopy[error] || errorsCopy.default;
    }
};



// WEBPACK FOOTER //
// ./assets/js/checkout/helpers/checkout-helpers.es.js